import { GoJsModelProperties } from '@y42/gojs';
import { DataLineageNodeTypes } from '@y42/json-schema';
import { Binding, GraphObject, Margin, Panel, Part, Shape, Spot } from 'gojs';
import { DataLineageModelProperties, DataLineageUINode } from '../../../../../../state/data-lineage-diagram';
import { DataLineageThemeColors } from './../../../../../../state/data-lineage-diagram/config/data-lineage.config';
import { nodeDetails } from './node-details';
import { nodeHeader } from './node-header';

const $ = GraphObject.make;

export const contentPanel = () =>
  $(
    Panel,
    Panel.Vertical,
    nodeHeader(),
    divider({}, [showNodeDetailsVisibilityBinding(), dividerStrokeBinding()]),
    nodeDetails({}, [showNodeDetailsVisibilityBinding()]),
  );

const divider = (props: Record<string, unknown> = {}, bindings: Binding[] = []): Shape =>
  $(
    Shape,
    {
      figure: 'Rectangle',
      strokeWidth: 0,
      width: 300,
      height: 1,
      alignment: Spot.Center,
      margin: new Margin(0, 0, 5, 0),
      ...props,
    },
    ...bindings,
  );

const showNodeDetailsVisibilityBinding = () =>
  new Binding('visible', '', (node: DataLineageUINode, part: Part) => {
    const showNodeDetailsModelData = part.diagram?.model.modelData[DataLineageModelProperties.ShowNodeDetails];
    const isNodeWithTable = [
      DataLineageNodeTypes.Integration,
      DataLineageNodeTypes.UiModel,
      DataLineageNodeTypes.SqlModel,
    ].includes(node.category);
    return !!showNodeDetailsModelData && isNodeWithTable;
  });

export const dividerStrokeBinding = () =>
  new Binding('fill', GoJsModelProperties.HasDarkMode, (hasDarkMode: boolean) =>
    hasDarkMode ? DataLineageThemeColors.Dark.NodeDivider : DataLineageThemeColors.Light.NodeDivider,
  ).ofModel();
